import { render, staticRenderFns } from "./devWarn1.vue?vue&type=template&id=7a1b8bd4&scoped=true&"
import script from "./devWarn1.vue?vue&type=script&lang=js&"
export * from "./devWarn1.vue?vue&type=script&lang=js&"
import style0 from "./devWarn1.vue?vue&type=style&index=0&id=7a1b8bd4&scoped=true&lang=css&"
import style1 from "./devWarn1.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a1b8bd4",
  null
  
)

export default component.exports